/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {FieldTable} from './fieldTable';
import {TableJoin} from './tableJoin';


export interface Table {
    anonymizable?: boolean;
    anonymizationAction?: Table.AnonymizationActionEnum;
    code: string;
    dataValidation?: Array<FieldTable>;
    description?: string;
    fields?: Array<FieldTable>;
    id?: string;
    importAutorise?: boolean;
    label?: string;
    labels?: { [key: string]: string; };
    schema: string;
    tableDependencies?: Array<TableJoin>;
    versioning?: boolean;
}
export namespace Table {
    export type AnonymizationActionEnum = 'REPLACE' | 'DELETE';
    export const AnonymizationActionEnum = {
        REPLACE: 'REPLACE' as AnonymizationActionEnum,
        DELETE: 'DELETE' as AnonymizationActionEnum
    };
}
